import { useLocation, Outlet } from 'react-router-dom';
import TopNav from '../../shared/top-nav';
import { isAbleToSeeUIElement } from '../../utils/roles/client-roles';
import { Link } from 'react-router-dom';
import { useUserSettings } from '../../utils/use-user-settings';
import { userPortalPagesConfig } from '../../shared/user-portal-pages-config';
import { allUserPortalPagesWithoutGroupDetails } from '../../shared/user-portal-pages-config';
import { useEffect, useRef } from 'react';
import { createUserLoggedInLog } from '../../api/users-api';

import Box from '@mui/material/Box';
import SharedTabCard from '../../shared/shared-tab-card';
import SharedTabContentCard from '../../shared/shared-tab-content-card';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

export default function UserPortalPage() {
  const { userViewRoles, usersTier, roleType } = useUserSettings();
  const location = useLocation();
  const lastPath = location.pathname.split('/').pop();
  const hasCreatedUserLoggedInLog = useRef(false);

  useEffect(() => {
    if (roleType === 'user' && !hasCreatedUserLoggedInLog.current) {
      createUserLoggedInLog();
      hasCreatedUserLoggedInLog.current = true;
    }
  }, []);

  return (
    <>
      <title>gPanel | User Portal</title>
      <Box
        component="main"
        sx={{
          py: 1,
          pl: 2,
          pr: 4,
        }}
      >
        <TopNav isUserPortal={true} />
      </Box>
      <Container maxWidth="xl">
        <Box sx={{ mt: 2, px: 4 }}>
          <SharedTabCard>
            <Tabs
              value={
                location.pathname.includes(
                  userPortalPagesConfig.userPortalAllGroups.link
                )
                  ? userPortalPagesConfig.userPortalAllGroups.link
                  : location.pathname.includes(
                      userPortalPagesConfig.userPortalMyGroups.link
                    )
                  ? userPortalPagesConfig.userPortalMyGroups.link
                  : lastPath !== userPortalPagesConfig.userPortal.link
                  ? lastPath
                  : userPortalPagesConfig.userPortalProfileInformation.link
              }
              variant="scrollable"
              allowScrollButtonsMobile
              scrollButtons={true}
              sx={{
                mx: 1,
                '& .MuiTabs-flexContainer': {
                  marginTop: '6px',
                },
                '.MuiTabs-scrollButtons.Mui-disabled': {
                  opacity: 0.3,
                },
              }}
            >
              {allUserPortalPagesWithoutGroupDetails.map((page) => {
                const doesntHavePermission =
                  !isAbleToSeeUIElement(
                    userViewRoles,
                    page.requiredPermission
                  ) && page.requiredPermission !== '*';
                const doesntHaveTier = usersTier.rank < page.minimumTier;

                if (doesntHavePermission || doesntHaveTier) {
                  return null;
                }

                return (
                  <Tab
                    key={page.link}
                    label={page.name}
                    value={page.link}
                    component={Link}
                    to={page.link}
                    icon={<page.icon />}
                    iconPosition="start"
                    sx={{
                      minHeight: '40px',
                      height: '40px',
                      width: 'fit-content',
                    }}
                  />
                );
              })}
            </Tabs>
          </SharedTabCard>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <SharedTabContentCard sx={{ minHeight: 420 }}>
              <Outlet />
            </SharedTabContentCard>
          </Stack>
        </Box>
      </Container>
    </>
  );
}
